import { forwardRef } from "react";
import { type FieldError } from "react-hook-form";

import { usePhoneInput } from "../../utils/phoneInputUtils";
import { formatPhoneNumber } from "../../utils/formatters";
import Input from "../FormInput";

interface PhoneInputProps {
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: FieldError;
  value: string;
  onChange: (value: string) => void;
  containerClass?: string;
  subText?: string;
  disabled?: boolean;
  id?: string;
  /** Optional — lets a form validate this field on blur. */
  onBlur?: () => void;
}

const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ onChange, placeholder = "(555) 123-4567", subText, value, ...props }, ref) => {
    const phoneHandlers = usePhoneInput(onChange);
    
    // Handle pre-formatted values by ensuring the display value is properly formatted
    const displayValue = value ? formatPhoneNumber(value) : "";
    
    return (
      <div className={props.containerClass}>
        <Input
          type="tel"
          placeholder={placeholder}
          maxLength={14} // (XXX) XXX-XXXX = 14 characters
          {...props}
          value={displayValue}
          {...phoneHandlers}
          ref={ref}
        />
        {subText && (
          <p className="text-xs text-muted-foreground mt-1">{subText}</p>
        )}
      </div>
    );
  }
);

PhoneInput.displayName = "PhoneInput";

export { PhoneInput };